export default {
  donation_form: {}
};
